import {
  FivetranServiceEnum,
  netsuiteSuiteanalyticsSchema,
} from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/**
 * Setup form for the NetSuite SuiteAnalytics Fivetran connector (token-based
 * authentication). Credentials come from NetSuite's "Set Up SuiteAnalytics
 * Connect" page, an Integration record, and an Access Token.
 */
export const NetsuiteSuiteanalyticsFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.netsuite_suiteanalytics,
    schema: netsuiteSuiteanalyticsSchema,
    defaultConfig: {
      schema: FivetranServiceEnum.enum.netsuite_suiteanalytics,
      host: "",
      port: "",
      account: "",
      datasource: "NetSuite2.com",
      role: "",
      consumer_key: "",
      consumer_secret: "",
      token_key: "",
      token_secret: "",
    },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="netsuite-suiteanalytics"
      submitLabel="Create"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />

      <div className="grid grid-cols-2 gap-4">
        <form.AppField name="config.host">
          {(field) => (
            <field.TextField
              label="Service host"
              placeholder="1234567.connect.api.netsuite.com"
            />
          )}
        </form.AppField>
        <form.AppField name="config.port">
          {(field) => (
            <field.TextField label="Service port" placeholder="1708" />
          )}
        </form.AppField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <form.AppField name="config.account">
          {(field) => (
            <field.TextField label="Account ID" placeholder="1234567" />
          )}
        </form.AppField>
        <form.AppField name="config.role">
          {(field) => <field.TextField label="Role ID" placeholder="3" />}
        </form.AppField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <form.AppField name="config.consumer_key">
          {(field) => <field.TextField label="Consumer key" />}
        </form.AppField>
        <form.AppField name="config.consumer_secret">
          {(field) => <field.PasswordField label="Consumer secret" />}
        </form.AppField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <form.AppField name="config.token_key">
          {(field) => <field.TextField label="Token ID" />}
        </form.AppField>
        <form.AppField name="config.token_secret">
          {(field) => <field.PasswordField label="Token secret" />}
        </form.AppField>
      </div>
    </ConnectionFormShell>
  );
};
